import { defineComponent as _defineComponent } from 'vue'
import { useConfigStore } from '@gms/stores/src/stores/config';
import { useThemeStore } from '@gms/stores/src/stores/theme';
import { AllThemes } from '../../../vuetify2-themes/dist';


export default /*#__PURE__*/_defineComponent({
  __name: 'BookNParkDevtoolsPanel',
  setup(__props) {

const themeStore = useThemeStore();
const configStore = useConfigStore();

/** The client the local and the staging API know; see libs/app-config. */
const STAGING_CLIENT_ID = '77cdcf98-c9ca-464d-a706-cf863134b639';

return { __sfc: true,themeStore, configStore, STAGING_CLIENT_ID, AllThemes }
}

})